const wrapRootElement = require('./gatsby/browser/wrap-root-element');

exports.wrapRootElement = wrapRootElement;
